/**
 * HAFA Zepto Mobile — Tab-Bar Auto-Scroll
 * --------------------------------------------------------------
 * Die Tab-Bar (.pplr_tab_wrapper) ist auf Mobile horizontal
 * scrollbar. Beim Tab-Wechsel (Klick auf Tab oder „Weiter zur
 * Stellstufe"-Button) scrollt dieses Script den aktiven Tab
 * (.pplr_active) automatisch in den sichtbaren Bereich.
 *
 * Stand: 2026-06-09 / schodyhafa.pl
 */
(function () {
  'use strict';

  function scrollActiveTabIntoView() {
    document.querySelectorAll('.pplr_tab_wrapper').forEach(function (wrapper) {
      var active = wrapper.querySelector('.pplr_tab_index.pplr_active');
      if (!active) return;
      // Nur scrollen wenn die Bar wirklich überläuft (Mobile)
      if (wrapper.scrollWidth <= wrapper.clientWidth + 4) return;

      var wRect = wrapper.getBoundingClientRect();
      var aRect = active.getBoundingClientRect();
      // Ziel: aktiver Tab mittig in der Bar
      var delta = (aRect.left + aRect.width / 2) - (wRect.left + wRect.width / 2);
      wrapper.scrollTo({ left: wrapper.scrollLeft + delta, behavior: 'smooth' });
    });
  }

  function init() {
    var wrappers = document.querySelectorAll('.pplr_tab_wrapper');
    if (!wrappers.length) return false;

    // Beobachte Klassen-Änderungen an den Tab-Items (pplr_active wandert)
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes' && m.attributeName === 'class' &&
            m.target.classList && m.target.classList.contains('pplr_tab_index')) {
          // kleines Delay, damit Zepto sein Rendering abgeschlossen hat
          setTimeout(scrollActiveTabIntoView, 80);
          return;
        }
      }
    });
    wrappers.forEach(function (w) {
      obs.observe(w, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });

    // Initial einmal ausrichten
    setTimeout(scrollActiveTabIntoView, 300);
    return true;
  }

  // Zepto rendert nach DOMContentLoaded — pollen bis die Tab-Bar da ist
  var tries = 0;
  function waitForZepto() {
    if (init()) return;
    if (++tries < 40) setTimeout(waitForZepto, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForZepto);
  } else {
    waitForZepto();
  }
})();
